(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosReunionNewController", LebaniegoYearContactosReunionNewController);

        LebaniegoYearContactosReunionNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearContactosReunion",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearContactosReunionNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearContactosReunion,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearContactosReunion = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");
        vm.sectors = ["Bebidas y alimentación de Cantabria", "Sector alimentario nacional", "Sector bebidas nacionales", "Sector fabricantes de aceite", "Empresas distribución", "Otros sectores"];
        vm.results = ["Interesado", "No Interesado", "Posponer Visita"];

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosReunion = Object.assign({}, vm.lebaniegoYearContactosReunion);
            lebaniegoYearContactosReunion.id = null;
            LebaniegoYearContactosReunion.save(lebaniegoYearContactosReunion, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-contacts-meeting", {});
        }

        function onSaveError() {
            toastr.error("Error al crear la reunión");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();